import {Injectable} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  /**
   * Checks if a validation error exists for the validator name.
   *
   * @param formControl InputComponent to check for errors.
   * @param validatorName error to look after.
   * @param showErrorMessage blocks the validation from happening if false
   * @return true if showError is true and the errors array has a value that equals the validatorName.
   */
  hasValidationFailed(
    formControl: {errors: object} | UntypedFormControl,
    validatorName: string,
    showErrorMessage: boolean,
  ): boolean {
    return (
      showErrorMessage &&
      !!formControl?.errors &&
      !!formControl.errors[validatorName as keyof typeof formControl.errors]
    );
  }
}
